import { render, staticRenderFns } from "./AddInstitutionConstituentForm.vue?vue&type=template&id=cfcfdbea&"
import script from "./AddInstitutionConstituentForm.vue?vue&type=script&lang=js&"
export * from "./AddInstitutionConstituentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports